export function inputNumberSpinner() {
    var formElement = document.getElementsByTagName('input');

    // loop through all elements on the page with class .form-input-spinner to connect spinner arrows with attached events
    for (let i = 0; i < formElement.length; i++) {
        if (formElement[i].classList.contains('form-element-input-spinner')) {
            addSpinnerArrows(formElement[i]);
        }
    }

}

const addSpinnerArrows = function (formElement: HTMLInputElement) {
    let parentElement = formElement.parentElement,
        formId = formElement.id,
        arrowMinus = parentElement.querySelector('.spinner-arrow-minus'),
        arrowPlus = parentElement.querySelector('.spinner-arrow-plus');

    arrowMinus.addEventListener("click", () => {
        spinnerClick(formId, 'substract');
    });

    arrowPlus.addEventListener("click", () => {
        spinnerClick(formId, 'add');
    });
}


// spinnerClick function is added to arrows on input number spinner
// function takes two arguments (formId and type)
// function checks if its an add or substract click and updates value on field based on formID
// function checks if max or min has been reached
// function adds or substracts by step number from input

const spinnerClick = function (formId: string, type: string) {
    let inputElement = document.getElementById(formId) as HTMLInputElement,
        inputValue: number = Number(inputElement.value),
        inputMax: number = Number(inputElement.max),
        inputMin: number = Number(inputElement.min);

    if (type === 'add' && inputValue < inputMax) {
        inputElement.stepUp();
        inputElement.dispatchEvent(new InputEvent("input"));
    } else if (type === 'substract' && inputValue != inputMin) {
        inputElement.stepDown();
        inputElement.dispatchEvent(new InputEvent("input"));
    }
}

